module.exports = __webpack_public_path__ + "static/media/015-Aktivierung_ID_37.64db5547.mp3";